"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Cache {
    constructor() {
        this.cache = new Map();
    }
    /**
     * @param {String} key (required) - cache key
     * @param {Object} value (required) - cache value
     * @param {Number} expire (optional) - cache expiration time (seconds), defaults to never expire
     * */
    set(key, value, ttl) {
        const expire = ttl ?
            (1000 * ttl) + Date.now() :
            9999999999999;
        this.cache.set(key, { value, expire });
    }
    /**
     * @param {String} key (required) - cache key to get
     * */
    get(key) {
        if (!key)
            throw new Error('key is required!');
        let record = this.cache.get(key);
        if (!record)
            return null;
        if (!record.expire || record.expire > Date.now())
            return record.value;
        else
            return this.remove(key);
    }
    /**
     * @param {String} key (required) - cache key to remove
     * */
    remove(key) {
        let record = this.cache.get(key);
        if (!record)
            return null;
        this.cache.delete(key);
        return null;
    }
}
exports.default = Cache;
